<div class="hover-container" *ngIf="serviceOrderHoverModel" [ngStyle]="serviceOrderHoverStyle">
  <div class="hover-container-arrow-right" [ngStyle]="arrowStyle" *ngIf="serviceOrderHoverModel.serviceOrder.laneNumber !== 0"></div>
  <div class="hover-container-arrow-left" [ngStyle]="arrowStyle" *ngIf="serviceOrderHoverModel.serviceOrder.laneNumber === 0"></div>
  <div class="hover-container-content">
    <div class="hover-container-content-logo" [ngStyle]="logoStyle">
      <div class="hover-container-content-logo-image" [ngStyle]="imageStyle"></div>
      <div class="hover-container-content-logo-type-name">{{serviceOrderTypeName | titlecase}} <span>({{serviceOrderHoverModel.serviceOrder.serviceOrderId}})</span></div>
    </div>
    <ng-container [ngSwitch]="serviceOrderHoverModel.serviceOrder.type">
      <app-medical-assessment-service-order-hover *ngSwitchCase="ServiceTypeEnum.MEDICAL_ASSESSMENT"
                                                  [serviceOrder]="serviceOrderHoverModel.serviceOrder"
                                                  [caseStakeholders]="caseStakeholder">
      </app-medical-assessment-service-order-hover>
      <app-coordination-transport-service-order-hover
        *ngSwitchCase="ServiceTypeEnum.COORDINATION_TRANSPORT"
        [serviceOrder]="serviceOrderHoverModel.serviceOrder"
        [providerName]="serviceOrderHoverModel.providerName"
        [agentName]="serviceOrderHoverModel.agentName"
        [linkedCasesStakeholders]="coordinatonCaseStakeholders"
        >
      </app-coordination-transport-service-order-hover>


      <app-major-incident-service-order-hover
        *ngSwitchCase="ServiceTypeEnum.MAJOR_INCIDENT"
        [serviceOrder]="serviceOrderHoverModel.serviceOrder"
        >
      </app-major-incident-service-order-hover>

      <app-base-service-order-hover *ngSwitchDefault
        [serviceOrder]="serviceOrderHoverModel.serviceOrder"
        [caseStakeholders]="caseStakeholder"
        [providerName]="serviceOrderHoverModel.providerName"
        [agentName]="serviceOrderHoverModel.agentName">
      </app-base-service-order-hover>
    </ng-container>
  </div>
</div>
